export default __webpack_public_path__ + "f88b38aac3aaaea2ff9c44c15f192a4b.gif";